import type { ReactNode } from 'react';
import { Box, DataTable, type TableColumns } from '@ff-it/ui';
import { scrollX } from './ProductList.css';

export type ProductListProps<TRow> = {
  rows: TRow[];
  columns: TableColumns<TRow>;
  getRowId: (row: TRow) => string;
  emptyState: ReactNode;
  ariaLabel?: string;
};

/**
 * Product-list presentation aligned with the TableColumns contract used by
 * route indexes. Product semantics live in injected columns rather than slots.
 */
export function ProductList<TRow>({ rows, columns, getRowId, emptyState, ariaLabel }: ProductListProps<TRow>) {
  return (
    <Box mt="2" role="region" aria-label={ariaLabel}>
      {rows.length === 0 ? (
        <Box border="default" borderRadius="md" p="4" fontSize="sm" color="gray600">
          {emptyState}
        </Box>
      ) : (
        <DataTable
          data={rows}
          size="xs"
          columns={columns}
          bordered
          getRowId={getRowId}
          tableContainerClassName={scrollX}
        />
      )}
    </Box>
  );
}
